export default "__VITE_ASSET__D6776QPu__"